/* eslint-disable */
import Parser from "./Parser";

export interface Indexable {
  [key: string]: any;
  id: any;
}

export default class Model {
  id: any;
  static type: string | undefined;

  constructor(data: any, included = []) {
    this.id = data.id;
    for (let key in data.attributes) {
      (this as Indexable)[key] = data.attributes[key];
    }

    for (const key in data.relationships) {
      const relation = data.relationships[key];
      if (relation) {
        (this as Indexable)[key] = Parser.parse(relation, included);
      }
    }
  }

  toJSON(): any {
    return { ...this };
  }

  toFormData() {
    const data = this.toJSON();
    const formData = new FormData();
    for (const key in data) {
      if (data[key] !== null && data[key] !== undefined) {
        if (Array.isArray(data[key])) {
          for (const value of data[key]) {
            formData.append(key + "[]", value);
          }
        } else {
          formData.append(key, data[key]);
        }
      }
    }
    return formData;
  }

  clone() {
    const klass = this.constructor;
    const cloned = new (klass as any)({
      id: this.id,
      attributes: [],
      relationship: [],
    });
    for (const key in this) {
      const current = this[key] as any;
      const descriptor = Reflect.getOwnPropertyDescriptor(this, key);

      if (!descriptor?.set || typeof current === "function") continue;

      if (typeof current?.clone === "function") {
        cloned[key] = current.clone();
      } else if (Array.isArray(current)) {
        cloned[key] = current.map((o) =>
          typeof o?.clone === "function" ? o.clone() : o
        );
      } else {
        cloned[key] = current;
      }
    }
    return cloned;
  }
}
